import { Grid } from "@mui/material";
import { LibraryFormProps } from "../api/types";
import { Outlet } from "react-router-dom";
import LibraryTabs from "./Tabs";

const Form = (props: LibraryFormProps) => {
  const editMode = props.library !== undefined;

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          <LibraryTabs />
        </Grid>
        <Grid item xs={12} md={9}>
          <Outlet context={editMode} />
        </Grid>
      </Grid>
    </>
  );
};

export default Form;
